// Supabase Auth (GoTrue) returns its own raw validation text, which reads as
// a wall of text dumped straight from a config string (e.g. spelling out the
// full alphabet twice) rather than something written for a user. Translate
// the ones we've actually seen; anything unrecognized still falls through to
// the raw message so we never silently swallow a real error.
export function friendlyAuthError(message: string): string {
  if (/character of each/i.test(message)) {
    return 'Password needs at least one lowercase letter, one uppercase letter, and one number.';
  }
  if (/at least (\d+) character/i.test(message)) {
    const match = message.match(/at least (\d+) character/i);
    return `Password must be at least ${match?.[1] ?? '8'} characters.`;
  }
  if (/should be different from the old password/i.test(message) || /same_password/i.test(message)) {
    return 'New password must be different from your current password.';
  }
  if (/current password required/i.test(message)) {
    return 'Enter your current password to confirm the change.';
  }
  if (/current password.*(incorrect|invalid|does not match|not correct)/i.test(message)) {
    return 'That current password is incorrect.';
  }
  if (/reauthenticat/i.test(message)) {
    return 'For security, please log out and back in before changing your password.';
  }
  return message;
}
